<template>
    <div>
        <!-- ALERT ERROR -->
        <a-alert
            v-if="errorMessage"
            type="error"
            :message="errorMessage"
            banner
            closable
            @close="errorMessage = null"
        />

        <!-- FILTER -->
        <ARow :gutter="[8, 8]">
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <FilterProvince
                    style="width: 100%"
                    v-model:value="state.params.province"
                    />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <FilterKabupatenKota
                    style="width: 100%"
                    v-model:provinsi="state.params.province"
                    v-model:value="state.params.city"
                    />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <FilterToko
                    style="width: 100%"
                    v-model:value="state.params.customerCode"
                    />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <AButton
                    type="primary"
                    title="Cari"
                    @click="fetchDataList"
                    :loading="state.isFetching">
                    <span
                        v-if="!state.isFetching"
                        class="fa fa-search"
                        aria-hidden="true"/>
                    <span v-else>
                        Memuat Data ...
                    </span>
                </AButton>
            </ACol>
        </ARow>

        <!-- DOWNLOAD EXCEL -->
        <div class="row justify-content-end mt-4">
            <div class="col-lg-6 col-md-12"></div>
            <div class="col-lg-6 col-md-12 text-right">
                <DownloadExcel
                :url="state.endpoint"
                :params="state.params"
                @errors="errorMessage = $event"
                />
            </div>
        </div>

        <!-- TABLE -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable
                :columns="state.columns"
                :data-source="state.data"
                :row-key="record => record.customerCode"
                size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :pagination="{
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} dari ${total} hasil`,
                total: state.meta.total,
                pageSize: state.meta.per_page,
                current: state.meta.page,
                }"
                @change="handleTableChange"
                :loading="state.isFetching">
                <template #no="{ index }">
                    <span>
                        {{ (state.meta.page - 1) * state.meta.per_page + index + 1 }}
                    </span>
                </template>
            </MdTable>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import FilterToko from '@/components/filter/FilterToko'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'

export default defineComponent({
    components: {
        FilterProvince,
        FilterKabupatenKota,
        FilterToko,
        DownloadExcel,
    },

    setup() {
        const errorMessage = ref(null)

        const state = reactive({
            data: [],
            meta: { total: 0, per_page: 10, page: 1 },
            columns: [
                { title: 'NO', slots: { customRender: 'no' } },
                { title: 'Kode Toko', dataIndex: 'customerCode' },
                { title: 'Nama Toko', dataIndex: 'customerName' },
                { title: 'Owner Name', dataIndex: 'ownerName' },
                { title: 'Sell Capacity', dataIndex: 'sellCapacity' },
                { title: 'Warehouse Capacity', dataIndex: 'warehouseCapacity' },
                { title: 'Latitude', dataIndex: 'latitude' },
                { title: 'Longitude', dataIndex: 'longitude' },
                { title: 'Provinsi', dataIndex: 'province' },
                { title: 'Kabupaten / Kota', dataIndex: 'city' },
                { title: 'Kode Pos', dataIndex: 'postalCode' },
                { title: 'Alamat', dataIndex: 'address' },
                { title: 'Status Data', dataIndex: 'status' },
                { title: 'Foto', dataIndex: 'photo' },
                { title: 'Tanggal Updated', dataIndex: 'updatedAt' },
                { title: 'Update Oleh', dataIndex: 'updatedBy' },
            ],
            endpoint: '/api/report-ats/customer-information',
            isFetching: false,
            params: extractQueryParams({
                q: '',
                province: [],
                city: [],
                customerCode: [],
                page: 1,
                perPage: 10,
            }),
        })

        const queryParams = () => {
            return {
                ...state.params,
                province: state.params.province.length ? state.params.province.join(',') : null,
                city: state.params.city.length ? state.params.city.join(',') : null,
                customerCode: state.params.customerCode.length ? state.params.customerCode.join(',') : null,
            }
        }

        const fetchDataList = async () => {
            state.isFetching = true
            errorMessage.value = null

            try {
                updateUrlWithQuery(state.params)
                const { data } = await apiClient.get(state.endpoint, { 
                    params: queryParams(), 
                })

                const customerData = data.data?.customerInformations ?? []
                const meta = data.data?.meta ?? {}

                state.data = customerData
                state.meta.total = meta.total ?? 0
                state.meta.per_page = meta.perPage ?? meta.per_page ?? 10
                state.meta.page = meta.currentPage ?? 1
            } catch (err) {
                errorMessage.value = err.message
            } finally {
                state.isFetching = false
            }
        }

        const handleTableChange = (pagination) => {
            state.params.page = pagination.current
            state.params.perPage = pagination.pageSize
            fetchDataList()
        }

        onMounted(() => {
            fetchDataList()
        })

        return {
            state,
            errorMessage,
            queryParams,
            fetchDataList,
            handleTableChange,
        }
    },
})
</script>
